import { useI18n } from 'vue-i18n'

export const translations = {
  en: {
    Headline: 'The right choice for thousands of retail businesses in all of Brazil',
    Subheadline: 'Complete management for your business'
  },
  'pt-br': {
    CampaignBannerAccent: 'estão aqui',
    CampaignBannerLabel: 'As soluções do seu food service estão aqui',
    CampaignBannerLine1: 'As soluções do',
    CampaignBannerLine2: 'seu food service',
    Headline: 'A escolha certa de milhares de lojistas em todo o Brasil',
    Subheadline: 'Gestão completa para o seu negócio'
  },
  es: {
    Headline: 'La elección correcta para miles de minoristas en todo Brasil',
    Subheadline: 'Gestión completa para tu negocio'
  },
  'en-US': {}
}

export const useTranslation = () => useI18n({ messages: translations })
